<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-select v-model="filter.status" clearable placeholder="状态" style="width: 120px" @change="getPosts">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="filter.category_id" clearable placeholder="分类" style="width: 120px" @change="getPosts">
            <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="filter.is_top" clearable placeholder="置顶" style="width: 110px" @change="getPosts">
            <el-option label="已置顶" :value="1"></el-option>
            <el-option label="未置顶" :value="0"></el-option>
          </el-select>
          <el-select v-model="filter.is_essence" clearable placeholder="精华" style="width: 110px" @change="getPosts">
            <el-option label="精华" :value="1"></el-option>
            <el-option label="非精华" :value="0"></el-option>
          </el-select>
          <el-input
            v-model="filter.keyword"
            clearable
            placeholder="搜索标题、作者、邮箱"
            prefix-icon="el-icon-search"
            style="width: 240px"
            @keyup.enter.native="getPosts"
          />
          <el-button type="primary" icon="el-icon-search" @click="getPosts">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
        </div>
        <div class="toolbar-count">
          <el-button size="small" icon="el-icon-picture-outline" @click="openCarouselList">轮播图管理</el-button>
          <span>共 {{ list.length }} 条帖子</span>
        </div>
      </div>

      <el-table :data="list" height="76vh" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column label="帖子" min-width="260">
          <template slot-scope="scope">
            <div class="post-title">{{ scope.row.title }}</div>
            <div class="muted">
              {{ categoryName(scope.row.category_id) }} · {{ scope.row.nickname || "未知用户" }}（UID：{{ scope.row.author_uid }}）
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="130">
          <template slot-scope="scope">
            <el-select size="mini" v-model="scope.row.status" @change="updatePost(scope.row, { status: scope.row.status })">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="推荐" width="190">
          <template slot-scope="scope">
            <div class="switch-line">
              <span>置顶</span>
              <el-switch
                v-model="scope.row.is_top"
                :active-value="1"
                :inactive-value="0"
                @change="updatePost(scope.row, { is_top: scope.row.is_top })"
              ></el-switch>
            </div>
            <div class="switch-line">
              <span>精华</span>
              <el-switch
                v-model="scope.row.is_essence"
                :active-value="1"
                :inactive-value="0"
                @change="updatePost(scope.row, { is_essence: scope.row.is_essence })"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="置顶排序" width="120">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              v-model="scope.row.top_sort"
              :min="0"
              :step="1"
              controls-position="right"
              style="width: 92px"
              @change="updatePost(scope.row, { top_sort: scope.row.top_sort })"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="数据" width="130">
          <template slot-scope="scope">
            <div>回复：{{ scope.row.reply_count || 0 }}</div>
            <div>浏览：{{ scope.row.view_count || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updated_at || scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="230">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openPost(scope.row)">正文</el-button>
            <el-button type="text" size="small" @click="openFloors(scope.row)">楼层</el-button>
            <el-button type="text" size="small" @click="openCarouselEdit(scope.row)">设轮播</el-button>
            <el-button type="text" size="small" @click="hidePost(scope.row)">隐藏</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="帖子正文" :visible.sync="postVisible" width="760px">
      <div class="dialog-title">{{ currentPost.title }}</div>
      <div class="muted">作者：{{ currentPost.nickname || "未知用户" }} · {{ formatTime(currentPost.created_at) }}</div>
      <el-divider></el-divider>
      <div class="post-html" v-html="currentPost.content_html"></div>
    </el-dialog>

    <el-dialog :title="'楼层管理 · ' + currentPost.title" :visible.sync="floorVisible" width="900px">
      <el-table :data="floorList" max-height="560" border>
        <el-table-column prop="floor_no" label="楼层" width="80"></el-table-column>
        <el-table-column label="用户" width="170">
          <template slot-scope="scope">
            <div>{{ scope.row.nickname || "未知用户" }}</div>
            <div class="muted">UID：{{ scope.row.author_uid }}</div>
          </template>
        </el-table-column>
        <el-table-column label="内容" min-width="260">
          <template slot-scope="scope">
            <div class="floor-content">{{ scope.row.content }}</div>
            <div class="image-list" v-if="parseImages(scope.row.images).length">
              <el-image
                v-for="(url, imageIndex) in parseImages(scope.row.images)"
                :key="imageIndex"
                :src="url"
                :preview-src-list="parseImages(scope.row.images)"
                fit="cover"
                class="thumb"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="130">
          <template slot-scope="scope">
            <el-select size="mini" v-model="scope.row.status" @change="updateFloor(scope.row)">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openFloorReplies(scope.row)">楼中楼</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="'楼中楼回复 · ' + currentFloor.floor_no + '楼'" :visible.sync="replyVisible" width="760px">
      <el-table :data="replyList" max-height="500" border>
        <el-table-column label="用户" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.nickname || "未知用户" }}</div>
            <div class="muted" v-if="scope.row.reply_to_nickname">回复：{{ scope.row.reply_to_nickname }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="260"></el-table-column>
        <el-table-column label="状态" width="130">
          <template slot-scope="scope">
            <el-select size="mini" v-model="scope.row.status" @change="updateFloorReply(scope.row)">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">{{ formatTime(scope.row.created_at) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="论坛轮播图管理" :visible.sync="carouselListVisible" width="960px">
      <el-table :data="carouselList" max-height="520" border>
        <el-table-column label="轮播图" width="160">
          <template slot-scope="scope">
            <el-image class="carousel-thumb" :src="scope.row.image" fit="cover" :preview-src-list="[scope.row.image]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="帖子" min-width="260">
          <template slot-scope="scope">
            <div class="post-title">{{ scope.row.title }}</div>
            <div class="muted">帖子ID：{{ scope.row.post_id }} · 作者：{{ scope.row.nickname || "未知用户" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="展示时长" width="120">
          <template slot-scope="scope">{{ Number(scope.row.duration_hours || 0) === 0 ? "一直展示" : scope.row.duration_hours + "小时" }}</template>
        </el-table-column>
        <el-table-column label="截止时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.end_at) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">{{ Number(scope.row.status) === 1 ? "启用" : "停用" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="editCarousel(scope.row)">编辑</el-button>
            <el-button type="text" class="danger" @click="deleteCarousel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="设置论坛轮播图" :visible.sync="carouselEditVisible" width="680px">
      <el-form :model="carouselForm" label-width="110px">
        <el-form-item label="帖子ID">
          <el-input-number v-model="carouselForm.post_id" :min="1" controls-position="right"></el-input-number>
          <span class="muted inline-tip">不填图片时将自动使用帖子第一张图</span>
        </el-form-item>
        <el-form-item label="轮播图">
          <div class="upload-line">
            <el-input v-model="carouselForm.image" placeholder="可上传或留空自动取帖子首图"></el-input>
            <el-upload
              action="/api/admin/forum/uploadcarousel-image"
              :headers="uploadHeaders"
              :show-file-list="false"
              accept=".png,.jpg,.jpeg,.gif,.webp"
              :on-success="uploadCarouselImageSuccess"
            >
              <el-button icon="el-icon-picture">上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="展示时长">
          <el-input-number v-model="carouselForm.duration_hours" :min="0" controls-position="right"></el-input-number>
          <span class="muted inline-tip">0 表示一直展示</span>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="carouselForm.sort" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch v-model="carouselForm.status" :active-value="1" :inactive-value="0" active-text="启用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="carouselEditVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCarousel">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, forumStatusOptions, isSuccess, normalizeImages } from "./appAdminUtils.js";

export default {
  name: "forumPosts",
  data() {
    return {
      statusOptions: forumStatusOptions,
      categories: [],
      filter: {
        status: "",
        keyword: "",
        category_id: "",
        is_top: "",
        is_essence: "",
      },
      list: [],
      postVisible: false,
      currentPost: {},
      floorVisible: false,
      floorList: [],
      currentFloor: {},
      replyVisible: false,
      replyList: [],
      carouselListVisible: false,
      carouselEditVisible: false,
      carouselList: [],
      carouselForm: this.emptyCarouselForm(),
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem("token") || "",
      };
    },
  },
  mounted() {
    this.getCategories();
    this.getPosts();
  },
  methods: {
    formatTime,
    parseImages: normalizeImages,
    emptyCarouselForm() {
      return {
        id: "",
        post_id: "",
        image: "",
        duration_hours: 0,
        sort: 0,
        status: 1,
      };
    },
    getCategories() {
      post("/api/admin/forum/categories", {}).then((res) => {
        if (isSuccess(res)) {
          this.categories = res.data.data || [];
        }
      });
    },
    categoryName(id) {
      const item = this.categories.find((category) => Number(category.id) === Number(id));
      return item ? item.name : "未分类";
    },
    getPosts() {
      post("/api/admin/forum/posts", this.filter).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "帖子列表获取失败");
        }
      });
    },
    resetFilter() {
      this.filter = {
        status: "",
        keyword: "",
        category_id: "",
        is_top: "",
        is_essence: "",
      };
      this.getPosts();
    },
    updatePost(row, changes) {
      const payload = Object.assign({ id: row.id }, changes);
      post("/api/admin/forum/updatepost", payload).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.getPosts();
        } else {
          this.$message.error(res.data.msg || "保存失败");
          this.getPosts();
        }
      });
    },
    hidePost(row) {
      this.$confirm("隐藏后帖子不会在 APP 正常展示，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.updatePost(row, { status: "deleted" });
      }).catch(() => {});
    },
    openPost(row) {
      this.currentPost = row;
      this.postVisible = true;
    },
    openFloors(row) {
      this.currentPost = row;
      this.floorVisible = true;
      this.getFloors(row.id);
    },
    getFloors(postId) {
      post("/api/admin/forum/floors", { post_id: postId }).then((res) => {
        if (isSuccess(res)) {
          this.floorList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "楼层列表获取失败");
        }
      });
    },
    updateFloor(row) {
      post("/api/admin/forum/updatefloor", { id: row.id, status: row.status }).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.getFloors(this.currentPost.id);
          this.getPosts();
        } else {
          this.$message.error(res.data.msg || "保存失败");
          this.getFloors(this.currentPost.id);
        }
      });
    },
    openFloorReplies(row) {
      this.currentFloor = row;
      this.replyVisible = true;
      this.getFloorReplies(row.id);
    },
    getFloorReplies(floorId) {
      post("/api/admin/forum/floor-replies", { floor_id: floorId }).then((res) => {
        if (isSuccess(res)) {
          this.replyList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "楼中楼回复获取失败");
        }
      });
    },
    updateFloorReply(row) {
      post("/api/admin/forum/updatefloorreply", { id: row.id, status: row.status }).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.getFloorReplies(this.currentFloor.id);
        } else {
          this.$message.error(res.data.msg || "保存失败");
          this.getFloorReplies(this.currentFloor.id);
        }
      });
    },
    openCarouselList() {
      this.carouselListVisible = true;
      this.getCarousels();
    },
    getCarousels() {
      post("/api/admin/forum/carousels", {}).then((res) => {
        if (isSuccess(res)) {
          this.carouselList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "轮播图列表获取失败");
        }
      });
    },
    openCarouselEdit(row) {
      this.carouselForm = Object.assign(this.emptyCarouselForm(), {
        post_id: row.id,
      });
      this.carouselEditVisible = true;
    },
    editCarousel(row) {
      this.carouselForm = Object.assign(this.emptyCarouselForm(), row);
      this.carouselEditVisible = true;
    },
    uploadCarouselImageSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.carouselForm.image = data.url;
    },
    saveCarousel() {
      if (!this.carouselForm.post_id) {
        this.$message.error("请填写帖子ID");
        return;
      }
      post("/api/admin/forum/savecarousel", this.carouselForm).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.carouselEditVisible = false;
          this.getCarousels();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    deleteCarousel(row) {
      this.$confirm("删除后 APP 论坛顶部不再展示该轮播图，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        post("/api/admin/forum/deletecarousel", { id: row.id }).then((res) => {
          if (isSuccess(res)) {
            this.$notify({ title: "删除成功", message: res.data.msg, type: "success" });
            this.getCarousels();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.toolbar-count,
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.toolbar-count {
  display: flex;
  align-items: center;
  gap: 12px;
}
.post-title {
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 6px;
}
.switch-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0;
}
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
  margin-bottom: 8px;
}
.post-html {
  max-height: 60vh;
  overflow: auto;
  line-height: 1.8;
}
.post-html img {
  max-width: 100%;
}
.floor-content {
  white-space: pre-wrap;
  line-height: 1.6;
}
.image-list {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.thumb {
  width: 58px;
  height: 58px;
  border-radius: 4px;
}
.carousel-thumb {
  width: 120px;
  height: 68px;
  border-radius: 4px;
  background: #eef7fb;
}
.upload-line {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
}
.inline-tip {
  margin-left: 12px;
}
.danger {
  color: #f56c6c;
}
</style>
